import Home from '../pages/home';
import Learning from '../pages/learning';
import Exam from '../pages/exam';
import ExamResult from '../pages/exam-result';
import Course from '../pages/course';

export default [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/course/:course',
        name: 'course',
        component: Course,
    },
    {
        path: '/course/:course/learning/:question',
        name: 'learning',
        component: Learning,
    },
    {
        path: '/course/:course/exam/result',
        name: 'exam.result',
        component: ExamResult,
    },
    {
        path: '/course/:course/exam/:question',
        name: 'exam.question',
        component: Exam,
    },
    {
        path: '*',
        component: Home
    }
];